import { Client, ClientPhone } from 'src/typings';

export function formatClientPhone(phone?: string | null): string {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length !== 10) return digits;
  return `(0${digits.slice(1, 3)}) ${digits.slice(3, 6)} ${digits.slice(6, 8)} ${digits.slice(
    8,
    10
  )}`;
}

export function getClientPhones(client?: Client | null): ClientPhone[] {
  if (!client?.phones) return [];
  return client.phones;
}

export function getClientPrimaryPhone(client?: Client | null): string | null {
  const phones = getClientPhones(client);
  const primary = phones.find((item) => item.isPrimary) || phones[0];
  return primary?.phone || client?.phone || null;
}

export function formatClientPhoneCompact(client?: Client | null): string {
  const phones = getClientPhones(client);
  const primary = getClientPrimaryPhone(client);
  const formattedPrimary = formatClientPhone(primary);

  if (!formattedPrimary) return '—';
  if (phones.length <= 1) return formattedPrimary;
  return `${formattedPrimary} +${phones.length - 1}`;
}

export function applyPhonesToClient(client: Client, phones: ClientPhone[]): Client {
  const primary = phones.find((item) => item.isPrimary) || phones[0];
  return {
    ...client,
    phones,
    phone: primary?.phone || null
  };
}
